import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(['block', $setup.wrapperClass])
  }, [
    ($props.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($props.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_Calendar, _mergeProps({
      "model-value": $setup.dateValue,
      placeholder: $props.placeholder,
      required: $props.required,
      "append-to": "body",
      "date-format": "dd/mm/yy",
      "input-class": "field",
      class: "qlts-date-picker"
    }, $setup.calendarAttrs, { "onUpdate:modelValue": $setup.onUpdate }), null, 16, ["model-value", "placeholder", "required", "onUpdate:modelValue"])
  ], 2))
}